(function () {
  'use strict';

  if (window.GBTracking && window.GBTracking.__version) return;

  var ATTRIBUTION_CACHE_KEY = 'gb_attribution_context_v1';
  var VIEWED_PRODUCT_KEY_PREFIX = 'gb_viewed_product_';
  var PURCHASE_TRACKED_KEY_PREFIX = 'gb_purchase_tracked_';
  var BEGIN_CHECKOUT_LOCK_MS = 1500;

  var beginCheckoutPromise = null;
  var lastBeginCheckoutAt = 0;
  var listenersBound = false;

  function nowMs() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function safeString(value) {
    return value == null ? '' : String(value);
  }

  function safeNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function round2(value) {
    return Number(safeNumber(value, 0).toFixed(2));
  }

  function normalizePrice(value) {
    var amount = safeNumber(value, 0);
    if (!amount || amount < 0) return 0;
    if (Math.abs(amount) > 999 && Math.floor(amount) === amount) {
      amount = amount / 100;
    }
    return round2(amount);
  }

  function cloneObject(source) {
    var target = {};
    if (!source || typeof source !== 'object') return target;
    Object.keys(source).forEach(function (key) {
      target[key] = source[key];
    });
    return target;
  }

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function getCookie(name) {
    var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, days) {
    var maxAge = safeNumber(days, 90) * 24 * 60 * 60;
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      String(maxAge) +
      '; samesite=lax';
  }

  function getQueryParams() {
    var params = {};
    var queryString = window.location.search || '';
    if (!queryString || queryString.length < 2) return params;

    if (typeof URLSearchParams !== 'undefined') {
      var searchParams = new URLSearchParams(queryString);
      searchParams.forEach(function (value, key) {
        if (value) params[key] = value;
      });
      return params;
    }

    queryString
      .replace(/^\?/, '')
      .split('&')
      .forEach(function (chunk) {
        if (!chunk) return;
        var parts = chunk.split('=');
        var key = decodeURIComponent(parts[0] || '');
        var value = decodeURIComponent(parts[1] || '');
        if (key && value) params[key] = value;
      });

    return params;
  }

  function readAttributionCache() {
    try {
      return parseJson(window.localStorage.getItem(ATTRIBUTION_CACHE_KEY), {}) || {};
    } catch (e) {
      return {};
    }
  }

  function writeAttributionCache(value) {
    try {
      window.localStorage.setItem(ATTRIBUTION_CACHE_KEY, JSON.stringify(value || {}));
    } catch (e) {}
  }

  function collectAttributionContext() {
    var query = getQueryParams();
    var cache = readAttributionCache();
    var next = cloneObject(cache);
    var keys = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'fbclid',
      'gclid',
      'ttclid',
      'msclkid'
    ];
    var changed = false;

    keys.forEach(function (key) {
      if (query[key]) {
        next[key] = query[key];
        changed = true;
      }
    });

    if (query.fbclid) {
      var existingFbc = getCookie('_fbc');
      if (!existingFbc || existingFbc.indexOf(query.fbclid) === -1) {
        setCookie('_fbc', 'fb.1.' + String(nowMs()) + '.' + query.fbclid, 90);
      }
    }

    if (!getCookie('_fbp')) {
      setCookie('_fbp', 'fb.1.' + String(nowMs()) + '.' + String(Math.floor(Math.random() * 10000000000)), 90);
    }

    next.fbp = getCookie('_fbp') || next.fbp || '';
    next.fbc = getCookie('_fbc') || next.fbc || '';

    if (changed) {
      next.ts = nowMs();
      writeAttributionCache(next);
    }

    return next;
  }

  var attributionContext = collectAttributionContext();

  function getAttributionContext() {
    if (!attributionContext || typeof attributionContext !== 'object') {
      attributionContext = {};
    }
    attributionContext.fbp = getCookie('_fbp') || attributionContext.fbp || '';
    attributionContext.fbc = getCookie('_fbc') || attributionContext.fbc || '';
    return attributionContext;
  }

  function sanitizeToken(value) {
    return safeString(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '')
      .slice(0, 24);
  }

  function buildEventId(eventName, seed) {
    var base = sanitizeToken(eventName || 'event') || 'event';
    var random = Math.random().toString(36).slice(2, 8);
    var seedPart = sanitizeToken(seed || '');
    return 'gb_' + base + '_' + nowMs().toString(36) + '_' + random + (seedPart ? '_' + seedPart : '');
  }

  function emitCustomEvent(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) {}
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) {}
  }

  function pushDataLayerEvent(name, detail) {
    window.dataLayer = window.dataLayer || [];
    if (!Array.isArray(window.dataLayer)) return;

    var payload = { event: name };
    if (detail && typeof detail === 'object') {
      Object.keys(detail).forEach(function (key) {
        payload[key] = detail[key];
      });
    }

    window.dataLayer.push(payload);
  }

  function trackMetaEvent(name, params, eventId) {
    if (window.GBTrackingDisableDirectMeta === true || window.GBTrackingDirectMeta === false) return false;
    if (typeof window.fbq !== 'function') return false;
    try {
      if (eventId) {
        window.fbq('track', name, params || {}, { eventID: eventId });
      } else {
        window.fbq('track', name, params || {});
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function normalizeItems(rawItems) {
    var sourceItems = Array.isArray(rawItems) ? rawItems : [];
    var items = [];

    sourceItems.forEach(function (rawItem) {
      if (!rawItem || typeof rawItem !== 'object') return;

      var itemId = safeString(rawItem.item_id || rawItem.id || rawItem.variant_id || '').trim();
      if (!itemId) return;

      var quantity = Math.max(1, Math.round(safeNumber(rawItem.quantity, 1)));
      var price = normalizePrice(
        rawItem.price != null
          ? rawItem.price
          : rawItem.item_price != null
            ? rawItem.item_price
            : rawItem.final_price
      );

      items.push({
        item_id: itemId,
        item_name: safeString(rawItem.item_name || rawItem.title || rawItem.product_title || '').trim(),
        item_variant: safeString(rawItem.item_variant || rawItem.option || rawItem.variant_title || '').trim(),
        quantity: quantity,
        price: price
      });
    });

    return items;
  }

  function buildItemsFromContents(rawPayload) {
    var ids = Array.isArray(rawPayload && rawPayload.content_ids) ? rawPayload.content_ids : [];
    var contents = Array.isArray(rawPayload && rawPayload.contents) ? rawPayload.contents : [];
    if (!ids.length && !contents.length) return [];

    var items = [];

    ids.forEach(function (id, index) {
      var content = contents[index] || {};
      items.push({
        item_id: safeString(id),
        item_name: '',
        item_variant: '',
        quantity: Math.max(1, Math.round(safeNumber(content.quantity, 1))),
        price: normalizePrice(content.item_price)
      });
    });

    if (!items.length) {
      contents.forEach(function (content) {
        if (!content || typeof content !== 'object') return;
        var id = safeString(content.id || content.item_id || '');
        if (!id) return;
        items.push({
          item_id: id,
          item_name: '',
          item_variant: '',
          quantity: Math.max(1, Math.round(safeNumber(content.quantity, 1))),
          price: normalizePrice(content.item_price)
        });
      });
    }

    return items;
  }

  function buildContentsFromItems(items) {
    return (items || []).map(function (item) {
      return {
        id: item.item_id,
        quantity: item.quantity,
        item_price: item.price
      };
    });
  }

  function computeTotals(items) {
    var totalQuantity = 0;
    var totalValue = 0;

    (items || []).forEach(function (item) {
      var qty = Math.max(1, Math.round(safeNumber(item.quantity, 1)));
      var price = normalizePrice(item.price);
      totalQuantity += qty;
      totalValue += price * qty;
    });

    return {
      total_quantity: totalQuantity,
      total_value: round2(totalValue)
    };
  }

  function normalizePayload(rawPayload, defaultSource) {
    var raw = rawPayload && typeof rawPayload === 'object' ? cloneObject(rawPayload) : {};
    var context = getAttributionContext();

    var currency =
      safeString(raw.currency || '') ||
      safeString(window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      safeString(window.Shopify && window.Shopify.currency && window.Shopify.currency.isoCode) ||
      'EUR';

    var items = normalizeItems(raw.items);
    if (!items.length) items = buildItemsFromContents(raw);

    var totals = computeTotals(items);
    var totalQuantity = Math.max(0, Math.round(safeNumber(raw.total_quantity, safeNumber(raw.num_items, totals.total_quantity))));
    var totalValue = normalizePrice(raw.total_value);

    if (!totalQuantity) totalQuantity = totals.total_quantity;
    if (!totalValue) totalValue = totals.total_value;

    var contentIds =
      Array.isArray(raw.content_ids) && raw.content_ids.length
        ? raw.content_ids.map(function (id) {
            return safeString(id);
          })
        : items.map(function (item) {
            return item.item_id;
          });

    var contents =
      Array.isArray(raw.contents) && raw.contents.length
        ? raw.contents.map(function (content) {
            return {
              id: safeString(content && (content.id || content.item_id) ? content.id || content.item_id : ''),
              quantity: Math.max(1, Math.round(safeNumber(content && content.quantity, 1))),
              item_price: normalizePrice(content && content.item_price)
            };
          })
        : buildContentsFromItems(items);

    return {
      source: safeString(raw.source || defaultSource || 'site') || 'site',
      stage: safeString(raw.stage || ''),
      product_id: safeString(raw.product_id || ''),
      product_handle: safeString(raw.product_handle || ''),
      product_title: safeString(raw.product_title || ''),
      currency: currency,
      total_quantity: totalQuantity,
      total_value: totalValue,
      total_value_cents: Math.round(totalValue * 100),
      num_items: totalQuantity,
      items: items,
      content_ids: contentIds,
      contents: contents,
      event_id: safeString(raw.event_id || ''),
      fbp: safeString(raw.fbp || context.fbp || ''),
      fbc: safeString(raw.fbc || context.fbc || ''),
      utm_source: safeString(context.utm_source || ''),
      utm_medium: safeString(context.utm_medium || ''),
      utm_campaign: safeString(context.utm_campaign || ''),
      utm_content: safeString(context.utm_content || ''),
      utm_term: safeString(context.utm_term || ''),
      fbclid: safeString(context.fbclid || ''),
      gclid: safeString(context.gclid || ''),
      ttclid: safeString(context.ttclid || ''),
      msclkid: safeString(context.msclkid || '')
    };
  }

  function appendAttributionFields(target, payload) {
    if (!target || typeof target !== 'object' || !payload || typeof payload !== 'object') return;

    var fields = [
      'fbp',
      'fbc',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'fbclid',
      'gclid',
      'ttclid',
      'msclkid'
    ];

    fields.forEach(function (field) {
      if (payload[field]) target[field] = payload[field];
    });
  }

  function trackAddToCart(rawPayload, options) {
    var opts = options || {};
    var payload = normalizePayload(rawPayload, rawPayload && rawPayload.source ? rawPayload.source : 'product-form');

    if (!payload.num_items) return null;

    if (!payload.event_id) {
      payload.event_id = buildEventId('add_to_cart', payload.content_ids[0] || payload.product_id || '');
    }

    var dataLayerPayload = {
      event_source: payload.source,
      event_id: payload.event_id,
      currency: payload.currency,
      value: payload.total_value,
      content_type: 'product',
      content_ids: payload.content_ids,
      contents: payload.contents,
      num_items: payload.num_items,
      product_id: payload.product_id,
      product_handle: payload.product_handle,
      product_title: payload.product_title,
      ecommerce: {
        currency: payload.currency,
        value: payload.total_value,
        items: payload.items
      }
    };

    appendAttributionFields(dataLayerPayload, payload);

    if (opts.pushDataLayer !== false) {
      pushDataLayerEvent('add_to_cart', dataLayerPayload);
    }

    if (opts.dispatchEvent !== false) {
      emitCustomEvent('gb:add_to_cart_success', payload);
    }

    trackMetaEvent(
      'AddToCart',
      {
        content_type: 'product',
        content_ids: payload.content_ids,
        contents: payload.contents,
        currency: payload.currency,
        value: payload.total_value,
        num_items: payload.num_items
      },
      payload.event_id
    );

    return payload;
  }

  function trackViewContent(rawPayload, options) {
    var opts = options || {};
    var payload = normalizePayload(rawPayload, rawPayload && rawPayload.source ? rawPayload.source : 'product-page');

    if (!payload.content_ids.length && payload.product_id) {
      payload.content_ids = [payload.product_id];
      payload.contents = [{ id: payload.product_id, quantity: 1, item_price: payload.total_value }];
      if (!payload.items.length) {
        payload.items = [
          {
            item_id: payload.product_id,
            item_name: payload.product_title,
            item_variant: '',
            quantity: 1,
            price: payload.total_value
          }
        ];
      }
      if (!payload.num_items) payload.num_items = 1;
    }

    if (!payload.content_ids.length) return null;

    if (!payload.event_id) {
      payload.event_id = buildEventId('view_content', payload.content_ids[0] || payload.product_id || '');
    }

    var dataLayerPayload = {
      event_source: payload.source,
      event_id: payload.event_id,
      currency: payload.currency,
      value: payload.total_value,
      content_type: 'product',
      content_ids: payload.content_ids,
      contents: payload.contents,
      num_items: payload.num_items || 1,
      product_id: payload.product_id,
      product_handle: payload.product_handle,
      product_title: payload.product_title,
      ecommerce: {
        currency: payload.currency,
        value: payload.total_value,
        items: payload.items
      }
    };

    appendAttributionFields(dataLayerPayload, payload);

    if (opts.pushDataLayer !== false) {
      pushDataLayerEvent('view_item', dataLayerPayload);
    }

    if (opts.dispatchEvent !== false) {
      emitCustomEvent('gb:view_content', payload);
    }

    trackMetaEvent(
      'ViewContent',
      {
        content_type: 'product',
        content_ids: payload.content_ids,
        contents: payload.contents,
        content_name: payload.product_title || undefined,
        currency: payload.currency,
        value: payload.total_value
      },
      payload.event_id
    );

    return payload;
  }

  function buildPayloadFromCart(cart, source) {
    var cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    var items = cartItems.map(function (item) {
      var quantity = Math.max(1, Math.round(safeNumber(item.quantity, 1)));
      var unitPrice = 0;

      if (item.final_line_price != null && quantity > 0) {
        unitPrice = normalizePrice(safeNumber(item.final_line_price, 0) / quantity);
      } else if (item.final_price != null) {
        unitPrice = normalizePrice(item.final_price);
      } else {
        unitPrice = normalizePrice(item.price);
      }

      return {
        id: safeString(item.variant_id || item.id || ''),
        quantity: quantity,
        price: unitPrice,
        title: safeString(item.product_title || item.title || ''),
        option: safeString(item.variant_title || '')
      };
    });

    return normalizePayload(
      {
        source: source || 'cart',
        currency: safeString(cart && cart.currency ? cart.currency : ''),
        total_value: normalizePrice(cart && cart.total_price),
        total_quantity: safeNumber(cart && cart.item_count, 0),
        items: items
      },
      source || 'cart'
    );
  }

  function executeBeginCheckoutTracking(payload, options) {
    var opts = options || {};
    if (!payload || !payload.num_items) return null;

    if (!payload.event_id) {
      payload.event_id = buildEventId('begin_checkout', payload.content_ids[0] || payload.product_id || '');
    }

    var dataLayerPayload = {
      event_source: payload.source,
      event_id: payload.event_id,
      currency: payload.currency,
      value: payload.total_value,
      content_type: 'product',
      content_ids: payload.content_ids,
      contents: payload.contents,
      num_items: payload.num_items,
      ecommerce: {
        currency: payload.currency,
        value: payload.total_value,
        items: payload.items
      }
    };

    appendAttributionFields(dataLayerPayload, payload);

    if (opts.pushDataLayer !== false) {
      pushDataLayerEvent('begin_checkout', dataLayerPayload);
    }

    if (opts.dispatchEvent !== false) {
      emitCustomEvent('gb:begin_checkout', payload);
    }

    trackMetaEvent(
      'InitiateCheckout',
      {
        content_type: 'product',
        content_ids: payload.content_ids,
        contents: payload.contents,
        currency: payload.currency,
        value: payload.total_value,
        num_items: payload.num_items
      },
      payload.event_id
    );

    return payload;
  }

  function trackBeginCheckout(rawPayload, options) {
    var opts = options || {};

    if (rawPayload && typeof rawPayload === 'object' && Array.isArray(rawPayload.items)) {
      var directPayload = normalizePayload(rawPayload, opts.source || rawPayload.source || 'checkout');
      return Promise.resolve(executeBeginCheckoutTracking(directPayload, opts));
    }

    var now = nowMs();
    if (!opts.force && now - lastBeginCheckoutAt < BEGIN_CHECKOUT_LOCK_MS) {
      return Promise.resolve(null);
    }
    lastBeginCheckoutAt = now;

    if (beginCheckoutPromise) return beginCheckoutPromise;

    beginCheckoutPromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_fetch_failed');
        return response.json();
      })
      .then(function (cart) {
        var payload = buildPayloadFromCart(cart, opts.source || 'checkout');
        return executeBeginCheckoutTracking(payload, opts);
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        beginCheckoutPromise = null;
      });

    return beginCheckoutPromise;
  }

  function buildPayloadFromCheckoutObject(checkout) {
    if (!checkout || typeof checkout !== 'object') return null;

    var lineItems = Array.isArray(checkout.line_items) ? checkout.line_items : [];
    var items = lineItems.map(function (item) {
      var quantity = Math.max(1, Math.round(safeNumber(item.quantity, 1)));
      var price = normalizePrice(item.price != null ? item.price : quantity > 0 ? safeNumber(item.line_price, 0) / quantity : 0);
      return {
        id: safeString(item.variant_id || item.id || ''),
        quantity: quantity,
        price: price,
        title: safeString(item.title || item.product_title || ''),
        option: safeString(item.variant_title || '')
      };
    });

    return normalizePayload(
      {
        source: 'checkout',
        currency: safeString(checkout.currency || checkout.presentment_currency || ''),
        total_value: normalizePrice(checkout.total_price || checkout.subtotal_price || 0),
        total_quantity: items.reduce(function (sum, item) {
          return sum + safeNumber(item.quantity, 0);
        }, 0),
        items: items
      },
      'checkout'
    );
  }

  function trackPurchaseFromCheckoutObject() {
    var checkout = window.Shopify && window.Shopify.checkout;
    if (!checkout || typeof checkout !== 'object') return null;

    var orderId = safeString(checkout.order_id || checkout.order_number || '').trim();
    if (!orderId) return null;

    var storageKey = PURCHASE_TRACKED_KEY_PREFIX + orderId;
    try {
      if (window.sessionStorage && window.sessionStorage.getItem(storageKey) === '1') {
        return null;
      }
    } catch (e) {}

    var payload = buildPayloadFromCheckoutObject(checkout);
    if (!payload || !payload.num_items) return null;

    payload.event_id = buildEventId('purchase', orderId);

    var dataLayerPayload = {
      event_source: payload.source,
      event_id: payload.event_id,
      transaction_id: orderId,
      currency: payload.currency,
      value: payload.total_value,
      content_type: 'product',
      content_ids: payload.content_ids,
      contents: payload.contents,
      num_items: payload.num_items,
      ecommerce: {
        transaction_id: orderId,
        currency: payload.currency,
        value: payload.total_value,
        items: payload.items
      }
    };

    appendAttributionFields(dataLayerPayload, payload);

    pushDataLayerEvent('purchase', dataLayerPayload);
    emitCustomEvent('gb:purchase', payload);

    trackMetaEvent(
      'Purchase',
      {
        content_type: 'product',
        content_ids: payload.content_ids,
        contents: payload.contents,
        currency: payload.currency,
        value: payload.total_value,
        num_items: payload.num_items
      },
      payload.event_id
    );

    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(storageKey, '1');
      }
    } catch (e) {}

    return payload;
  }

  function findInputByName(form, inputName) {
    if (!form || !inputName) return null;
    var inputs = form.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i += 1) {
      if (inputs[i].name === inputName) return inputs[i];
    }
    return null;
  }

  function ensureHiddenInput(form, inputName, value) {
    if (!form || !inputName || !value) return;

    var input = findInputByName(form, inputName);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      form.appendChild(input);
    }

    input.value = value;
  }

  function isCartForm(form) {
    if (!form) return false;
    if (form.id === 'cart' || form.id === 'CartDrawer-Form') return true;

    var action = safeString(form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart') !== -1) return true;

    return Boolean(form.querySelector('[name="checkout"]'));
  }

  function hydrateCheckoutForm(form) {
    if (!isCartForm(form)) return;

    var context = getAttributionContext();

    if (context.fbp) ensureHiddenInput(form, 'attributes[_fbp]', context.fbp);
    if (context.fbc) ensureHiddenInput(form, 'attributes[_fbc]', context.fbc);
    if (context.utm_source) ensureHiddenInput(form, 'attributes[_utm_source]', context.utm_source);
    if (context.utm_medium) ensureHiddenInput(form, 'attributes[_utm_medium]', context.utm_medium);
    if (context.utm_campaign) ensureHiddenInput(form, 'attributes[_utm_campaign]', context.utm_campaign);
    if (context.utm_content) ensureHiddenInput(form, 'attributes[_utm_content]', context.utm_content);
    if (context.utm_term) ensureHiddenInput(form, 'attributes[_utm_term]', context.utm_term);
    if (context.fbclid) ensureHiddenInput(form, 'attributes[_fbclid]', context.fbclid);
    if (context.gclid) ensureHiddenInput(form, 'attributes[_gclid]', context.gclid);
    if (context.ttclid) ensureHiddenInput(form, 'attributes[_ttclid]', context.ttclid);
    if (context.msclkid) ensureHiddenInput(form, 'attributes[_msclkid]', context.msclkid);
  }

  function hydrateCheckoutForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i += 1) {
      hydrateCheckoutForm(forms[i]);
    }
  }

  function resolveFormFromElement(element) {
    if (!element) return null;
    if (element.form) return element.form;

    var formId = safeString(element.getAttribute && element.getAttribute('form') ? element.getAttribute('form') : '');
    if (formId) return document.getElementById(formId);

    return element.closest ? element.closest('form') : null;
  }

  function bindCheckoutListeners() {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target && event.target.closest
          ? event.target.closest('button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, a[href*="/checkout"]')
          : null;
        if (!target) return;

        var form = resolveFormFromElement(target);
        if (form) hydrateCheckoutForm(form);

        var source = target.id === 'CartDrawer-Checkout' ? 'cart-drawer' : target.tagName === 'A' ? 'checkout-link' : 'cart';
        trackBeginCheckout(null, { source: source });
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.tagName !== 'FORM' || !isCartForm(form)) return;

        hydrateCheckoutForm(form);

        var source = form.id === 'CartDrawer-Form' ? 'cart-drawer-form' : 'cart-form';
        trackBeginCheckout(null, { source: source });
      },
      true
    );
  }

  function markViewedProduct(variantId) {
    if (!variantId) return;
    var key = VIEWED_PRODUCT_KEY_PREFIX + variantId + ':' + window.location.pathname;
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(key, '1');
      }
    } catch (e) {}
  }

  function wasProductViewed(variantId) {
    if (!variantId) return false;
    var key = VIEWED_PRODUCT_KEY_PREFIX + variantId + ':' + window.location.pathname;
    try {
      if (window.sessionStorage) {
        return window.sessionStorage.getItem(key) === '1';
      }
    } catch (e) {}
    return false;
  }

  function trackProductViewFromContext() {
    var context = window.gbTrackingContext;
    if (!context || context.template !== 'product' || !context.product) return;

    var product = context.product;
    var variantId = safeString(product.variant_id || product.variantId || '').trim();
    if (!variantId || wasProductViewed(variantId)) return;

    var price = normalizePrice(product.price);

    var tracked = trackViewContent(
      {
        source: 'product-page',
        product_id: safeString(product.id || ''),
        product_handle: safeString(product.handle || ''),
        product_title: safeString(product.title || ''),
        currency: safeString(context.currency || product.currency || ''),
        total_value: price,
        total_quantity: 1,
        items: [
          {
            id: variantId,
            quantity: 1,
            price: price,
            title: safeString(product.title || ''),
            option: ''
          }
        ]
      },
      { pushDataLayer: true, dispatchEvent: true }
    );

    if (tracked) {
      markViewedProduct(variantId);
    }
  }

  function onReady() {
    attributionContext = collectAttributionContext();
    hydrateCheckoutForms();
    bindCheckoutListeners();
    trackProductViewFromContext();
    trackPurchaseFromCheckoutObject();
  }

  window.GBTracking = {
    __version: '1.0.0',
    buildEventId: buildEventId,
    normalizePayload: normalizePayload,
    pushDataLayerEvent: pushDataLayerEvent,
    trackMetaEvent: trackMetaEvent,
    trackAddToCart: trackAddToCart,
    trackViewContent: trackViewContent,
    trackBeginCheckout: trackBeginCheckout,
    hydrateCheckoutForm: hydrateCheckoutForm,
    hydrateCheckoutForms: hydrateCheckoutForms,
    trackPurchaseFromCheckoutObject: trackPurchaseFromCheckoutObject,
    getAttributionContext: getAttributionContext
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
